import { NavLink } from "react-router-dom";

const TABS = [
    ["/mentions-legales", "Mentions légales"],
    ["/politique-de-confidentialite", "Politique de confidentialité"],
    ["/conditions-utilisation", "Conditions d’utilisation"],
];

export const LegalLayout = ({ title, subtitle, testid, children }) => (
    <div data-testid={testid}>
        <div className="mx-auto max-w-[900px] px-4 md:px-8 lg:px-12 pt-10 md:pt-16 lg:pt-20 pb-12 md:pb-16 lg:pb-24 flex flex-col gap-6">
            <div className="text-[13px] font-semibold uppercase tracking-[0.16em] text-gold-text">Informations légales</div>
            <nav aria-label="Documents légaux" className="flex flex-wrap gap-2">
                {TABS.map(([to, label]) => (
                    <NavLink
                        key={to}
                        to={to}
                        data-testid={`legal-tab-${to.slice(1)}`}
                        className={({ isActive }) =>
                            `min-h-[44px] px-[18px] inline-flex items-center rounded-full border-[1.5px] text-sm transition-colors ${
                                isActive ? "border-navy bg-navy text-cream font-semibold" : "border-border-strong bg-white text-navy font-medium hover:border-navy"
                            }`
                        }
                    >
                        {label}
                    </NavLink>
                ))}
            </nav>
            <article className="bg-white border border-border-default rounded-2xl p-[22px] md:p-11 flex flex-col gap-[18px] animate-fade-up">
                <h1 className="m-0 font-bold text-[28px] md:text-[42px] leading-[1.15] tracking-[-0.02em] text-navy">{title}</h1>
                <div className="w-[120px] h-1.5 bg-gold" />
                {subtitle && <p className="m-0 text-sm text-grey-text-soft">{subtitle}</p>}
                <div className="prose-legal">{children}</div>
            </article>
        </div>
    </div>
);
